import { render } from "./add-member.vue?vue&type=template&id=6c708b8a&scoped=true"
import script from "./add-member.vue?vue&type=script&lang=js"
export * from "./add-member.vue?vue&type=script&lang=js"

import "./add-member.vue?vue&type=style&index=0&id=6c708b8a&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c708b8a"]])

export default __exports__